import styled from 'styled-components'

export default styled.p`
  font-size: 1em;
  margin: 0px;
  align-self: center;
  flex: 1;
`